export default "__VITE_ASSET__CANkw6da__"